export const UPGRADE_RECOMMENDATION_TIMEOUT_MS = 3000;
export const UPGRADE_RECOMMENDATION_URL = '/_api/premium-package-pickers-api/get-upgrade-recommendation';
export const getUpgradeRecommendationQueryFn = async _ref => {
  let {
    httpClient,
    request
  } = _ref;
  const response = await httpClient.post(UPGRADE_RECOMMENDATION_URL, request, {
    timeout: UPGRADE_RECOMMENDATION_TIMEOUT_MS
  });
  return {
    ...response.data,
    requestId: response.requestId
  };
};
//# sourceMappingURL=get-upgrade-recommendation.query.js.map